// Team Members
import team1 from "../assets/images/team/Olufolake Zion.jpg";
import team2 from "../assets/images/team/Joy Eze.jpg";
import team4 from "../assets/images/team/Tolu.jpg";
// import team5 from "../assets/images/team/Allen-Praise3.jpg";
import team6 from "../assets/images/team/Daniel.jpg";
import team7 from "../assets/images/team/Tobi.jpg";
import team8 from "../assets/images/team/Chinemerem.jpg";
import team9 from "../assets/images/team/Alade Esther.jpg";
import team10 from "../assets/images/team/Ayopelumi.jpg";
import team11 from "../assets/images/team/Ife.jpg";
import team12 from "../assets/images/team/Tosin.jpg";

import speaker1 from "../assets/images/speakers/ayodeji_omonijo.jpg";
import speaker2 from "../assets/images/speakers/yusuf_balogun.jpg";
import speaker3 from "../assets/images/speakers/Malik.jpg";
import speaker4 from "../assets/images/speakers/opeyemi_temenu.jpg";
import speaker5 from "../assets/images/speakers/kelechi_achinonu.jpg";
import speaker6 from "../assets/images/speakers/emmanuel_ade.jpg";
import speaker7 from "../assets/images/speakers/covenant_odedele.jpg";
import speaker8 from "../assets/images/speakers/Michael_oladele.jpg";
import speaker9 from "../assets/images/speakers/Senami.jpg";
import speaker10 from "../assets/images/speakers/Kachi.jpg";
import speaker11 from "../assets/images/speakers/Dotun.jpg";
import speaker12 from "../assets/images/speakers/Dami.jpg";

// Past Speakers
import img1 from "../assets/images/pspeakers/buchi.png";
import img2 from "../assets/images/pspeakers/toyin.png";
import img3 from "../assets/images/pspeakers/emmanuel.png";
import img4 from "../assets/images/pspeakers/renee.png";
import img5 from "../assets/images/pspeakers/kolapo.png";
import img6 from "../assets/images/pspeakers/tolu.png";
import img7 from "../assets/images/pspeakers/kelvin.png";
import img8 from "../assets/images/pspeakers/mary.png";
import img9 from "../assets/images/pspeakers/gbenga.png";

import event1 from "../assets/images/event/1.jpg";
import event2 from "../assets/images/event/2.jpg";
import event3 from "../assets/images/event/3.jpg";
import event4 from "../assets/images/event/4.jpg";
import event5 from "../assets/images/event/5.jpg";
import event6 from "../assets/images/event/6.jpg";
import event7 from "../assets/images/event/7.jpg";
import event9 from "../assets/images/event/9.jpg";
import event10 from "../assets/images/event/10.jpg";
import event11 from "../assets/images/event/11.jpg";
import event12 from "../assets/images/event/12.jpg";

import unknown from "../assets/images/unknown.png";

import { FaPeopleArrows, FaGraduationCap } from "react-icons/fa";
import { LiaTheaterMasksSolid } from "react-icons/lia";

export const images = [event1, event6, event5, event3, event2, event12, event4, event11, event10, event11, event9, event7];

export const menuItems = [
  {
    title: "Quick Links",
    links: [
      { title: "About Us ", url: "/about" },
      { title: "Speakers", url: "/speakers" },
      { title: "Organizers", url: "/organizers" },
      { title: "Sponsors", url: "/sponsors" },
      { title: "Blogs", url: "/blogs" },
    ],
  },
  {
    title: "Community",
    links: [
      // { title: "Volunteers", url: "/volunteers" },
      // { title: "Our Partners", url: "/partners" },
      { title: "Past Event", url: "https://www.youtube.com/@tedxoau9629" },
      { title: "Support", url: "mailto:partnership@tedxoau.com" },
      { title: "Contact Us", url: "mailto:info@tedxoau.com" },
    ],
  },
  {
    title: "Social Links",
    links: [
      { title: "Twitter", url: "https://Twitter.com/tedxoauofficial" },
      { title: "Instagram", url: "https://Instagram.com/tedxoauofficial" },
      {
        title: "LinkedIn",
        url: "https://www.linkedin.com/company/tedxoauofficial/",
      },

      { title: "Threads", url: "https://www.threads.net/@tedxoauofficial" },
      {
        title: "YouTube",
        url: "https://linktr.ee/tedxoauofficial?fbclid=PAAaYKWuKFaKSp3HpH29JV2vc_qtKhpnFRMYJhJii9wVF-IvRJaaA4sBaDpvA",
      },
    ],
  },
];

// Final merged array
export const pastSpeakersData = [
  {
    name: "Dennis Osadebe",
    role: "Visual Artist",
    img: img1,
  },
  {
    name: "Oluwatoyin Sodipe",
    role: "Career Coach and Mentor",
    img: img2,
  },
  {
    name: "Emmanuel Faith",
    role: "HR Professional",
    img: img3,
  },
  {
    name: "Renée Chuks",
    role: "Co-Founder at Aldente Africa",
    img: img4,
  },
  {
    name: "Kolapo Oladapo",
    role: "Business & Strategic Manager",
    img: img5,
  },
  {
    name: "Toluwanimi Akinrinola",
    role: "Founder, The Girl Life",
    img: img6,
  },
  {
    name: "Kelvin Umechukwu",
    role: "Co-founder & CEO of Bumpa",
    img: img7,
  },
  {
    name: "Mary Bukola Taiwo",
    role: "SRHR Advocate",
    img: img8,
  },
  {
    name: "Gbenga Adeku",
    role: "Upcycle Artist",
    img: img9,
  },
  // New Speakers
  {
    name: "Ayodeji Omonijo",
    role: "Tech Enthusiast and CEO, Techspace Academy",
    img: speaker1,
  },
  {
    name: "Yusuf Balogun",
    role: "Art Specialist, Author, and Performance Poet",
    img: speaker2,
  },
  {
    name: "Opeyemi Temenu",
    role: "Technical Account Manager at Flutterwave",
    img: speaker4,
  },
  {
    name: "Michael Oladele",
    role: "Writer and Marketing Professional",
    img: speaker8,
  },
  {
    name: "Kelechi Achinonu",
    role: "Justice Advocate and Founder, TechLawyered",
    img: speaker5,
  },
  {
    name: "Emmanuel A. Olowookere",
    role: "Medical Doctor and Founder, ÌTÀN",
    img: speaker6,
  },
  {
    name: "Covenant Odedele",
    role: "Medical Student, UI and Social Impact Advocate",
    img: speaker7,
  },
  {
    name: "Senami Anko",
    role: "Lecturer, LASU and Founder, The Green Life",
    img: speaker9,
  },
  {
    name: "Ukachi Eze-Mbey",
    role: "Founder, DIY's by Kachi and Electrical Engineering Graduate.",
    img: speaker10,
  },
  {
    name: "Dotun Popoola",
    role: "A Metal Sculptor and CEO, DOTs Studio",
    img: speaker11,
  },
  {
    name: "Damilola Ademilokun",
    role: "Founder, Obsidian Advisory Africa",
    img: speaker12,
  },
  {
    name: "Malik Afegbua",
    role: "A Renowned Filmmaker, Artist and Designer",
    img: speaker3,
  },
];

export const NavLinks = [
  {
    id: 1,
    url: "/",
    text: "Home",
  },

  {
    id: 2,
    url: "/about",
    text: "About",
  },

  {
    id: 3,
    url: "/speakers",
    text: "Speakers",
  },

  {
    id: 4,
    url: "/organizers",
    text: "Executive Team",
  },

  {
    id: 5,
    url: "/sponsors",
    text: "Sponsors",
  },
  {
    id: 6,
    url: "/blog",
    text: "Blog",
  },
  {
    id: 7,
    url: "/event",
    text: "Past Events",
  },
];

export const questionsData = [
  {
    id: 1,
    title: "What is TEDxOAU?",
    info: "TEDxOAU is an independently organized TED-like event hosted by students of Obafemi Awolowo University. It brings together a diverse group of speakers and attendees to share ideas and spark discussions on a wide range of topics, from technology and science to arts and social issues.",
  },

  {
    id: 2,
    title: " How can I attend TEDxOAU?",
    info: "To attend TEDxOAU, you'll need to secure a ticket once they become available. Ticket information, including pricing and availability, will be shared on our official website and social media channels. Keep an eye out for announcements to ensure you don't miss your chance to be part of this inspiring event.",
  },
  {
    id: 3,
    title: " Who can speak at TEDxOAU?",
    info: "At TEDxOAU, we welcome speakers from various backgrounds and expertise. Our speakers include professionals, students, academics, activists, artists, and individuals with unique perspectives. The selection process is competitive, and potential speakers are chosen based on the originality and relevance of their ideas, as well as their ability to communicate them effectively.",
  },
  {
    id: 4,
    title: "Can I suggest a speaker or topic for TEDxOAU?",
    info: "Absolutely! We value community involvement and encourage you to nominate potential speakers or suggest intriguing topics that you believe would be a great fit for TEDxOAU. Keep an eye on our website and social media platforms for any open calls for speaker nominations or topic suggestions.",
  },
  {
    id: 5,
    title: "Will the talks be available after the event?",
    info: "Yes, the talks presented at TEDxOAU will be recorded and made available to the public after the event. We believe in the power of sharing ideas, and our goal is to spread these innovative and thought-provoking talks far and wide. You'll be able to watch or share the talks on our official website and TEDxOAU's YouTube channel. ",
  },
];

export const tabData = [
  {
    title: "TED",
    content:
      "TED is a nonprofit organization devoted to Ideas Worth Spreading. Started as a four-day conference in California 30 years ago, TED has grown to support its mission with multiple initiatives. The two annual TED Conferences invite the world’s leading thinkers and doers to speak for 18 minutes or less. Many of these talks are then made available for free at TED.com. TED speakers have included Bill Gates, Jane Goodall, Elizabeth Gilbert, Sir Richard Branson, Nandan Nilekani, Philippe Starck, Ngozi Okonjo-Iweala, Sal Khan, and Daniel Kahneman. The annual TED Conference takes place each spring in Vancouver, British Columbia. TED’s media initiatives include TED.com, where new TED Talks are posted daily; TED Translators, which provides subtitles and interactive transcripts as well as translations from volunteers worldwide; and the educational initiative, TED-Ed. TED has established The Audacious Project which takes a collaborative approach to funding ideas with the potential to create change at thrilling scales; TEDx, which supports individuals or groups in hosting local, self-organized TED-style events around the world; and the TED Fellows program, which helps world-changing innovators from around the globe to amplify the impact of their remarkable projects and activities. Follow TED on Twitter or on at Facebook",
  },
  {
    title: "TEDx",
    content:
      "In the spirit of ideas worth spreading, TED has created a program called TEDx. TEDx is a program of local, self-organized events that bring people together to share a TED-like experience. Our event is called TEDxOAU, where x = independently organized TED event. At TEDxOAU, TED Talks videos and live speakers will combine to spark deep discussion and connection in a small group. The TED Conference provides general guidance for the TEDx program, but individual TEDx events, including ours, are self-organized.",
  },

  {
    title: "TEDxOAU",
    content:
      "TEDxOAU is an independently organized TED event under an authorized license from TED at Obafemi Awolowo University, Ile-Ife. It is an initiative that aims to bring together a socially conscious community in OAU and involve young people in discussions about IDEAS WORTH SPREADING. Holding for the second time ever, and after a four-year hiatus—TEDxOAU targets an audience of students, young professionals, and academic members of staff. The conference hopes to shine the spotlight on interdisciplinary speakers — including those from the local community — who will ignite action, and encourage innovation and critical discussion.",
  },
];

export const benefitData = [
  {
    icon: <FaPeopleArrows />,
    title: "Networking",
    description:
      "TEDxOAU events attract a diverse audience, including professionals, students, and enthusiasts. Attending provides an opportunity to connect with like-minded individuals, potential mentors, or collaborators.",
  },
  {
    icon: <FaGraduationCap />,
    title: "Learning Opportunities",
    description:
      "Speakers at TEDx events share insights, experiences, and knowledge that can be educational. You may learn about new ideas, innovations, or concepts that you were not previously familiar with.",
  },
  {
    icon: <LiaTheaterMasksSolid />,
    title: "Entertainment",
    description:
      "TEDxOAU talks are designed to be engaging and entertaining. The format often includes storytelling and visuals, making the content more enjoyable and memorable.",
  },
];

export const ticketData = [
  {
    title: "Regular",
    description: "For a budget-friendly experience.",
    price: "2,000",
    // slashedPrice: "2,500",
  },
  {
    title: "Vanguard",
    description: "For an enjoyable experience.",
    price: "5,000",
    // slashedPrice: "4,000",
  },
  {
    title: "Standard",
    description: "For an over-the-top experience",
    price: "7,000",
    // slashedPrice: "6,000",
  },
  {
    title: "Premium",
    description: "For a lavish and exclusive conference experience",
    price: "10,000",
    // slashedPrice: "9,000",
  },
  {
    title: "Donor",
    description: "An act of generosity that supports TEDxOAU’s mission.",
    price: "50,000",
    // slashedPrice: "45,000",
  },
];

export const benefits = [
  // Benefits for Regular
  [
    "All-day conference experience",
    "Conference Meal - Breakfast",
    "Live Stream Access",
    "Conference photo and video archive",
    "Access to TEDxOAU Community",
  ],

  // Benefits for Vanguard
  [
    "All-day conference experience",
    "Conference meal: Breakfast and snacks for lunch",
    "Conference pack: Includes conference tag and souvenir",
    "Live videostream access",
    "One professional head shot",
    "Conference photo and video archive",
    "Access to TEDxOAU Community",
  ],
  // Benefits for Standard
  [
    "All day conference experience",
    "Conference meal: Breakfast and packaged meal for Lunch",
    "Conference pack: Includes conference tag and souvenir",
    "Live videostream access",
    "One professional headshot",
    "Conference photo and video archive",
    "Access to TEDxOAU Community",
    "Opportunity to transfer ticket ownership",
  ],
  // Benefits for Premium
  [
    "All day conference experience",
    "Conference meal: Breakfast and packaged meal for Lunch",
    "Conference pack: Includes conference tag and souvenir",
    "Exclusive access to a networking party with speakers and organizers",
    "Early access to conference venue",
    "Live videostream access",
    "One professional head shot",
    "Conference photo and video archive",
    "Access to the TEDxOAU community",
    "Opportunity to transfer ticket ownership",
  ],
  // Benefits for Donor
  [
    "All day conference experience",
    "Conference meal: Breakfast and packaged meal for Lunch",
    "Conference pack: Includes conference tag and souvenir",
    "Exclusive access to a networking party with speakers and organizers",
    "Early access to conference venue",
    "Live videostream access",
    "One professional head shot",
    "Conference photo and video archive",
    "Access to the TEDxOAU community",
    "Onstage and social media recognition",
    "Cross collaboration on social media",
  ],
];

export const teamMembers = [
  {
    name: "Olufolake Zion",
    role: "Licensee",
    image: team1,
    bio: "Olufolake is a project manager, brand communications coordinator, and a final-year student at Obafemi Awolowo University. She's passionate about promoting lifelong learning, environmental and social sustainability, and empowers Gen Zs through her monthly publication 'Hues and Echoes' Apart from her professional pursuits, she loves adventure and exploration, constantly seeking to broaden her horizons. As the Licensee of TEDXOAU, she plays roles as a project manager, marketing director, and catalyst for sparking meaningful conversations.",
  },

  {
    name: "Joy Obioma Eze",
    role: "Co-licensee",
    image: team2,
    bio: "I'm a Digital Marketer, Content Writer, and yes, a singer too! Living life on my own terms is my jam, and my motto is simple - keep keeping on! ;) Life's too short not to have fun, and I'm all about making positive changes and having a blast on this journey.",
  },

  {
    name: "Tolu Oluwadare",
    role: "Curations Lead",
    image: team4,
    bio: "In one word, I'm an analyst. In many words, am a data analyst, economist, writer and policy nerd. You'd likely find me watching movies set in medieval times, playing candy crush, reading Stears Business and earning badges on Duolingo. I must add that I am convinced that amala is mid.",
  },

  {
    name: "Daniel Adeoye",
    role: "Design Lead",
    image: team6,
    bio: "Well... out goes my mysteriousness. People call me KW. On nights, I'm not out saving Gotham, I pretty much design, edit pictures and videos, or brainstorm new creative ideas. During the day, I keep a straight face. But trust me, I'm not so bad when you meet me.",
  },

  {
    name: "Tobiloba Ibraheem",
    role: "Web Development Lead",
    image: team7,
    bio: "Tobiloba Ibraheem, a passionate front-end developer with an insatiable curiosity for all things web-re-lated. With an eye for detail and a flair for creativity. His coding journey began with a thirst for know-edge, constantly learning and mastering the latest technologies to stay ahead in the dynamic world of frontend development. ",
  },

  {
    name: "Ajala Joy Chinemerem",
    role: "Volunteer Recruitment Lead",
    image: team8,
    bio: "Looking for that one person who is a parrot on any online platform but a dove in person? Then you should meet me! enjoy meeting people online before bringing the conversations to real life, and once I get comfortable with you, I promise I am the sweetest person you will ever meet.You will always find me smiling, except you meet me walking on the streets of Lagos, especially Mushin 🤣",
  },

  {
    name: "Alade Esther Tinuola",
    role: "Digital Marketing Lead",
    image: team9,
    bio: "You already know my name, but these days, people call me agbasocialmedia (feel free to call me that too!).I'm not one for picking favourites when it comes to colours or food, but let me tell you what I'm absolutely obsessed with - Social Media and my newfound love, Marketing! Whether it is working with business owners or indi-viduals, I'm all about making an impact!",
  },

  {
    name: "Ayomide O. Adekola",
    role: "Event Management Lead",
    image: team10,
    bio: "Ayomide O. Adekola is an experienced Project Manager with over 3 years of managing projects online and on-site. Trained in project management, data analysis, monitoring and evaluation, time manage-ment, leadership, budgeting, strategy development and implementation and, teamwork and effective communication. She's also a recent graduate of Human Development and Family Relations from Obafemi Awolowo University.",
  },

  {
    name: "Ifeoluwa Williams",
    role: "Production Lead",
    image: team11,
    bio: "Ifeoluwa Williams is a a photographer and videographer, also a production manager. Simply put, I really love media space. I like to work on projects that get me really engaged as I learn from them. I work well with a team. I like music, movies, documentaries too.",
  },

  {
    name: "Ajetunmobi Tosin",
    role: "Content Creation Lead",
    image: team12,
    bio: "I'm Tosin, that's it and that's really all you need to know.…but since you are still reading, I might as well share some more. I enjoy everything about writing, growth and leadership. I'm a people's person and I like to impact lives with every opportunity I get.",
  },
];

// export const speakerData = [
//   {
//     id: 1,
//     name: "",
//     role: "Tech Enthusiast and CEO, Techspace Academy",
//     image: speaker1,
//     linkedin: "https://www.linkedin.com/in/ayodeji-omonijo-735392225/",
//     instagram: "https://www.instagram.com/ayodejiomonijo1/",
//     twitter: "https://twitter.com/AyodejiOmonijo1",
//     bio: "An active problem solver and a versatile individual whose journey seamlessly navigates the intricate realms of medicine, technology, and education. As the co-founder of Techspace Academy, a pioneering Edutech startup, his unwavering commitment lies in fostering tech literacy and empowering individuals to wholeheartedly embrace the constantly evolving landscape of technology. Ayodeji is a gifted UI/UX designer adept at crafting intuitive digital experiences, a medical student studying Physiotherapy at the Obafemi Awolowo University, and his unconventional blend of followers embodies his curiosity and the boundless scope of his expertise.",
//   },

//   {
//     id: 2,
//     name: "Yusuf Balogun",
//     role: "Art Specialist, Author, and Performance Poet",
//     image: speaker2,
//     linkedin: "https://ng.linkedin.com/in/yusuf-balogun-gemini-a1492319b",
//     instagram: "https://www.instagram.com/aremogemini/?hl=en",
//     twitter: "https://twitter.com/AremoGemini",
//     bio: 'An accomplished individual, deeply dedicated to the rich heritage of Yoruba art and culture, Yusuf, acclaimed as "Aremo Gemini," has earned recognition as a recipient of the prestigious Horn of Afro Classical Merit Award in 2018, including BBC Yoruba and Folio Media. Yusuf is an art specialist spurred by significant drives, one of which is to sell out the O2 Arena, London for Yoruba Oral Arts. He also stands as the celebrated author of the best-selling Yoruba novel, "Segilola Aromire Ogidan," a literary masterpiece that has garnered accolades not only on the African continent but also beyond its borders.',
//   },

//   // {
//   //   id: 3,
//   //   name: "Opeyemi Olugbemiro",
//   //   role: "Communication and Branding Professional ",
//   //   image: speaker3,
//   //   linkedin: "https://ng.linkedin.com/in/opeyemi-olugbemiro",
//   //   instagram: "https://www.instagram.com/o_gbemiro/",
//   //   twitter: "https://twitter.com/o_gbemiro?lang=en",
//   //   bio: "Opeyemi Olugbemiro is a seasoned content strategist and a dynamic communicator, renowned for his prowess in assisting brands in shaping lasting connections with their employees, stakeholders, and customers through the power of content. He has worked with founders and cross-functional teams to tell compelling stories across diverse mediums, define their purpose and values, and build templates that help them connect with their target audience. With a vast spectrum of experience spanning print, radio, and digital platforms, Opeyemi stands out as the preferred partner for narrating brand tales, not only within the borders of Africa but also globally.",
//   // },

//   {
//     id: 4,
//     name: "Opeyemi Temenu",
//     role: "Technical Account Manager at Flutterwave",
//     image: speaker4,
//     linkedin: "https://ng.linkedin.com/in/opeyemitemenu",
//     instagram: "https://instagram.com/opeyemi_tem1",
//     twitter: "https://twitter.com/horpeh_tems",
//     bio: "A fervent creative visionary with a remarkable aptitude for delivering practical solutions, Opeyemi's expertise spans across user-centric roles within a diverse array of industries, including Oil and Gas, Banking, Telecoms, and Fintech. As an Alumnus of Electronic and Electrical Engineering at OAU, Opeyemi currently manages technical relationships of enterprise clients with Flutterwave where he innovatively helps them achieve their goals. When he is not refining user experience and solving problems, he is found passionately volunteering. He is passionate about impacting youths, enjoys spirited games of table tennis, and more recently, working out at the gym.",
//   },

//   {
//     id: 5,
//     name: "Michael Oladele",
//     role: "Writer and Marketing Professional ",
//     image: speaker8,
//     linkedin:
//       "https://www.linkedin.com/in/michaelinioluwaoladele?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
//     instagram: "https://www.instagram.com/michaelinioluwa/",
//     twitter: "https://x.com/michaelinioluwa?s=21&t=jhw9ldawP3_D8ARFSmvCDw",
//     bio: "Michael Oladele is a versatile professional, wielding his skills as a writer, marketing expert, and storyteller. Over the last two years, he's made significant strides, notably at Cowrywise, a prominent Fintech company in Nigeria, where he played a pivotal role in nurturing the expansive Cowrywise Ambassadors Community. Beyond his corporate endeavours, Michael takes the lead as the mastermind behind Marketers Therapy Session, a dynamic meetup that unites tech marketers to delve into the latest marketing trends and strategies. As a wordsmith and marketing maven, he crafts compelling articles and threads that engage with pertinent societal issues impacting the youth and Gen Z demographic. Additionally, Michael is dedicated to capturing African Literature by interviewing African authors and sharing their journeys on YouTube.",
//   },

//   {
//     id: 6,
//     name: "Kelechi Achinonu",
//     role: "Justice Advocate and Founder, TechLawyered",
//     image: speaker5,
//     linkedin: "https://ng.linkedin.com/in/kelechiachinonu",
//     instagram: "https://instagram.com/kelechiachinonu?igshid=MzRlODBiNWFlZA==",
//     twitter: "https://x.com/kelechiachinonu?s=21&t=jhw9ldawP3_D8ARFSmvCDw",
//     bio: "Kelechi Achinonu is a passionate advocate for justice on a mission to harness technology for a more efficient and accessible legal system. As the visionary behind TechLawyered, she's driving tech integration in law and shining a spotlight on innovators in Africa's justice arena. Leading as the Head of the Hague Institute for Innovation of Law (HiiL), Justice Accelerator in West Africa, Kelechi is actively shaping strategies to make justice easily accessible, aligning with HiiL's mission to assist 150 million people in resolving their legal challenges by 2030. Notably, she's a United Nations Foundation Next Generation Fellow for Justice and a Young Justice Leader with the Pathfinders for Peaceful, Just, and Inclusive Societies.",
//   },

//   {
//     id: 8,
//     name: "Emmanuel A. Olowookere",
//     role: "Medical Doctor and Founder, ÌTÀN",
//     image: speaker6,
//     linkedin: "https://ng.linkedin.com/in/emmanuel-adeoluwa-olowookere-5620b3120",
//     instagram: "https://www.instagram.com/a_king_from_oau/?hl=en",
//     twitter: "https://twitter.com/a_king_from_oau?lang=en",
//     bio: "An intentional public health enthusiast and seasoned medical expert with much appetite for development, change, and transformation in humans and businesses. In 2020, he established ÌTÀN, an online community boasting over 1100 aspiring change-makers, and in 2017, he pioneered S & W Tags, a brand dedicated to crafting tags, badges, and labels for students, organizations, and companies. He is also a Business and Brand specialist and has utilized thousands of dollars, investing significantly in digital advertising campaigns for various brands, including his notable work on The Voice Nigeria. He currently holds pivotal roles as a Product Marketer and Chief of Staff at two esteemed organizations, all while serving as the Head of House Officers at the Federal Medical Centre in Ebute Metta.",
//   },

//   {
//     id: 7,
//     name: "Covenant Odedele",
//     role: "Medical Student, UI and Social Impact Advocate ",
//     image: speaker7,
//     linkedin: "https://ng.linkedin.com/in/covenant-odedele-2aab7b1b0",
//     instagram: "https://www.instagram.com/covenantodedele/?hl=en",
//     twitter: "https://x.com/visionarykoveh?s=21&t=jhw9ldawP3_D8ARFSmvCDw",
//     bio: "Covenant Odedele, a visionary and medical student at the University of Ibadan, is deeply immersed in social innovation, entrepreneurship, leadership, and civic engagement. As the Founder of 'Students on LinkedIn', he's impacted over 3000 students across 15+ countries, earning the distinction of being the youngest Nigerian recipient of the 2023 Princess Diana Award, among other accolades. Currently holding the role of Public Relations Officer for the Union of Campus Journalists at the University of Ibadan, Covenant is also a 2023 Fellow of The Carrington Fellowship. His achievements have been featured in prominent publications, and he clinched victory in the 2023 Naija Policy Hackathon. Covenant is resolutely committed to harnessing the campus demographic for innovative contributions to bolster Nigeria and Africa's economic prosperity.",
//   },

//   {
//     id: 9,
//     name: "Senami Anko",
//     role: "Lecturer, LASU and Founder, The Green Life ",
//     image: speaker9,
//     linkedin:
//       "https://www.linkedin.com/in/senami-anko-1ab58410a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
//     instagram: "https://instagram.com/the_greenelife?igshid=MzNlNGNkZWQ4Mg==",
//     twitter: "https://twitter.com/Senami_Anko?t=zI-frhpE4F_WRud5QXHUkA&s=09",
//     bio: "A dedicated Environmental Chemistry Lecturer at Lagos State University who holds a Bachelor's and Master's in Chemistry from the same institution. Currently pursuing a Ph.D. in Environmental Chemistry, her passion lies in nature and sustainability. She conducts impactful research focusing on Goals 3, 6, and 14. Senami Anko has an impressive record, presenting at renowned conferences worldwide, and her research has earned her prestigious awards such as, Commonwealth Chemistry Posters Award and Grant, Royal Society of Chemistry; as well as the NOBCCHE Tier 1 Award and Grant, USA. Her current work addresses food security and waste management in underserved communities, emphasizing food processing, preservation, and organic fertilizer production to support local farmers. She champions sustainability through her activism platform, The Greene Life, advocating for a cleaner environment and pollution eradication. She's an enthusiastic learner with certifications in Google Data Analytics and the McKinsey Forward Programme.",
//   },

//   {
//     id: 10,
//     name: "Ukachi Eze-Mbey",
//     role: "Founder, DIY's by Kachi and Electrical Engineering Graduate.",
//     image: speaker10,
//     linkedin: "https://ng.linkedin.com/in/ukachi-eze-mbey-201610180",
//     instagram: "https://www.instagram.com/naturalkachi/ ",
//     twitter: "https://twitter.com/naturalkachi",
//     bio: "Ukachi Eze Mbey, a recent graduate of Electrical and Electronics Engineering at Obafemi Awolowo University, is a vibrant individual passionate about both Engineering and Cosmetology, with a strong inclination toward the latter. Her true passion lies in African Natural Hair. Driven by a desire to challenge beauty norms and boost self-confidence, she founded DIYs by Kachi, a natural hair care company dedicated to African Hair. With nearly 7 years of experience, harmed with a diploma in Cosmetology, Ukachi has become a beacon in the natural hair community, amassing a devoted following of over 65,000 enthusiasts on her beauty platforms, thanks to her radiant personality and deep knowledge of African hair.",
//   },

//   {
//     id: 11,
//     name: "Dotun Popoola",
//     role: "A Metal Sculptor and CEO, DOTs Studio ",
//     image: speaker11,
//     linkedin: "https://www.linkedin.com/in/dotun-popoola-a5409563/",
//     instagram: "https://www.instagram.com/dotundavid_popoola/",
//     twitter: "https://twitter.com/dotunpopoo",
//     bio: "Dotun Popoola is a synergetic metal sculptor hailing from Agege, Lagos, who has made a remarkable mark in the art world. He honed his craft through his education at Obafemi Awolowo University, Nigeria. His journey led him to become a certified hybrid metal sculptor at John Lopez Studio, USA, in 2015. Dotun's artistry has garnered numerous accolades, including the 2009 NYSC Arts Competition Director General's Award. He has showcased his talents at esteemed events like 'ART X Lagos' and represented Nigeria globally.  With a passion for transforming scraps into treasures and rubbish into rubies, Dotun not only creates art but also nurtures others through workshops. His monumental sculptures grace locations worldwide, and his influence extends to mentoring artists in his Nigerian studio. An eight-year tenure as a curator for the National Gallery of Arts, Nigeria, showcases his deep commitment to the art world. Dotun Popoola's global contributions have earned recognition from over 50 publications and TV stations, including prestigious names like the New York Times, BBC, and Al Jazeera.",
//   },

//   {
//     id: 12,
//     name: "Damilola Ademilokun",
//     role: "Founder, Obsidian Advisory Africa ",
//     image: speaker12,
//     linkedin: "https://www.linkedin.com/in/damilola-ademilokun/?originalSubdomain=ng",
//     instagram: "https://www.instagram.com/thefashioncareercoach/",
//     twitter: "https://twitter.com/DAdemilokun",
//     bio: "Damilola Ademilokun, a seasoned fashion industry expert, boasts a decade of experience and a track record of success. As the Founder and CEO of Obsidian Advisory Africa, a prominent fashion career and recruitment firm, she's dedicated to linking top talent with leading fashion brands, catalyzing growth, and nurturing innovation. She annually organizes the Fashion Career Summit & Fair, a highly regarded event uniting industry leaders, emerging talent, and investors. Damilola excels in talent acquisition, career coaching, and organizational development in the fashion sector, with a mission to maximize professional potential and build exceptional teams. Her enthusiasm for industry innovation drives her to explore emerging trends, sustainability initiatives, and cutting-edge technologies. She is a globally-minded entrepreneur fostering collaborations within the African and global fashion community.",
//   },

//   {
//     id: 12,
//     name: "Malik Afegbua",
//     role: "A Renowned Filmmaker,  Artist and Designer ",
//     image: speaker3,
//     linkedin: "https://www.linkedin.com/in/malik-afegbua-04606b66/",
//     instagram: "https://www.instagram.com/slickcityceo/",
//     twitter: "https://twitter.com/slickcityceo",
//     bio: "Malik Afegbua is a celebrated Nigerian filmmaker and artist, who gained global acclaim in January 2023 for his innovative use of AI technology in the world of arts. His 'Elder' series, featuring seniors on a stylish fashion runway through AI-generated imagery, catapulted him to internet stardom and drew the attention of renowned brands and organizations worldwide. As the founder of Slickcity Media, Malik has produced captivating content for brands like American Express and Meta, and since his viral rise, he's collaborated with industry giants like Marvel Studios, IBM, and Cadbury. Notably, the World Health Organization and Academy Award-winning costume designer Ruth E. Carter praised him for his significant contribution to combatting ageism and celebrated his work.",
//   },
// ];

export const speakerData = [
  {
    id: 1,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
  {
    id: 2,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
  {
    id: 4,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
  {
    id: 5,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
  {
    id: 6,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
  {
    id: 8,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
  {
    id: 7,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
  {
    id: 9,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
  {
    id: 10,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
  {
    id: 11,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
  {
    id: 12,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
  {
    id: 12,
    name: "",
    role: "",
    image: unknown,
    linkedin: "",
    instagram: "",
    twitter: "",
    bio: "",
  },
];
